import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { UserActivityBuilder } from '../../models/builders/user-activity.builder';
import { UserActivity } from '../../models/user-activity';
import { ErpTaskBuilder } from '../../models/builders/erp-task.builder';
import { UserActivityTypeBuilder } from '../../models/builders/user-activity-type.builder';

const userActivityBody = (userActivity: UserActivity) => ({
  name: userActivity.name,
  erpTask: userActivity.erpTask,
  type: userActivity.typeCode
});

@Injectable()
export class UserActivityApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }userActivities`;
  }

  createUserActivity(userActivity) {
    return this.httpClient.post(this.apiUrl, userActivityBody(userActivity)).pipe(map(UserActivityBuilder.fromJson));
  }

  deleteUserActivity(userActivity: UserActivity) {
    return this.httpClient.delete(`${ this.apiUrl }/${ userActivity.hash }`);
  }

  getUserActivities() {
    return this.httpClient.get(`${ this.apiUrl }/userActivities`).pipe(map(UserActivityBuilder.fromList));
  }

  getUserActivity(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(UserActivityBuilder.fromJson));
  }

  updateUserActivity(userActivity: UserActivity) {
    return this.httpClient.put(`${ this.apiUrl }/${ userActivity.hash }`, userActivityBody(userActivity));
  }

  getErpTasks() {
    return this.httpClient.get(`${ this.apiUrl }/erp-tasks`).pipe(map(ErpTaskBuilder.fromList));
  }

  getUserActivitiesByUser(user: string) {
    const params = new HttpParams().append('user', user);
    return this.httpClient.get(`${ this.apiUrl }/user`, { params }).pipe(map(UserActivityBuilder.fromList));
  }

  getUserActivitiesByValidation(hash: string) {
    const params = new HttpParams().append('validation', hash);
    return this.httpClient.get(`${ this.apiUrl }/validation`, { params }).pipe(map(UserActivityBuilder.fromList));
  }

  getSearchUserActivitiesByUser(user: string, search: string) {
    const params = new HttpParams().append('user', user).append('search', search);
    return this.httpClient.get(`${ this.apiUrl }/searchByUser`, { params })
    .pipe(
      map(UserActivityBuilder.fromList)
    );
  }

  getUserActivityTypes() {
    return this.httpClient.get(`${ this.apiUrl }/types`)
      .pipe(
        map(UserActivityTypeBuilder.fromList)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/user-activity-api.service.ts